import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GroupMemberService } from '@schoolbelle/api/group-member';
import { padNumbersInsideString } from '@schoolbelle/common/functions';
import { PhoneNumberPipe } from '@schoolbelle/common/phone-number';
import { GroupMember } from '@schoolbelle/api/group-member';
import { orderBy, padStart } from 'lodash';
import { of, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { TableSearchService } from './table-search.service';

@Component({
  selector: 'app-table-search',
  templateUrl: './table-search.component.html',
  styleUrls: ['./table-search.component.css'],
  providers: [PhoneNumberPipe],
})
export class TableSearchComponent implements OnInit {
  @Input() member_types:string = 'student,parent';
  @Output() onSelect = new EventEmitter<GroupMember>();
  constructor(
    private member:GroupMemberService,
    private phoneNumberPipe:PhoneNumberPipe,
    private tableSearchService:TableSearchService,
  ) { }

  list:GroupMember[] = [];
  subscription = new Subscription();
  ngOnInit() {
    const member_types = this.member_types.split(',');


    this.subscription.add(
      this.member.onChange.pipe(
        startWith(null),
      ).subscribe(()=>{
        this.list = this.member.list.filter(m=>member_types.includes(m.member_type));
      })
    );
  }
  ngOnDestroy () {
    this.subscription.unsubscribe();
  }
  getMatchedMemberList (q:string) {
    q = q.replace(/[-[\]{}()*+?.,\\^$|#]/g, '');
    const $list =of(this.list)
    .pipe(
      map(list=>list.map(m=>({
        raw:`${m.group_name} ${m.member_name || m.student_member_name} ${this.phoneNumberPipe.transform(m.member_phone_number) || ''} ${m.member_phone_number || ''}`,
        display:`${m.group_name} ${m.member_name || m.student_member_name} ${this.phoneNumberPipe.transform(m.member_phone_number) || ''}`, 
        member:m
      }))),

      map(list=>{
        list = list.filter(li=>li.raw.replace(/[\(\)\-]/g, '').match(new RegExp(q.replace(/[\(\)\-]/g, ''))));
        list = list.filter(li=>li.member.member_type !== 'parent' || li.member.member_phone_number);
        list = orderBy(list, li=>{
          const m = li.member;
          return `${padNumbersInsideString(m.group_name)}-${m.student_member_num || m.member_num}`;
        });
        return list;
      }),
    );
    return $list;
  }  
  select (member:GroupMember) {
    if (member) {
      this.onSelect.next(member);
      this.tableSearchService.onSelect.next(member);
    }
  }

}
